<script setup>
import { onMounted, ref } from 'vue';
import AOS from 'aos';

import iconHeavyVehicle from '@/assets/vehicle.png';
import iconStorage from '@/assets/warehouse.png';
import iconTraining from '@/assets/education.png';

const expertiseItems = ref([
  {
    titleKey: 'expertise-page.body.exp.heavy.tit',
    icon: iconHeavyVehicle,
    points: [
      'expertise-page.body.exp.heavy.txt[0]',
      'expertise-page.body.exp.heavy.txt[1]',
      'expertise-page.body.exp.heavy.txt[2]',
    ],
  },
  {
    titleKey: 'expertise-page.body.storage-and-transportation.tit',
    icon: iconStorage,
    points: [
      'expertise-page.body.storage-and-transportation.txt[0]',
      'expertise-page.body.storage-and-transportation.txt[1]',
      'expertise-page.body.storage-and-transportation.txt[2]',
      'expertise-page.body.storage-and-transportation.txt[3]',
    ],
  },
  {
    titleKey: 'expertise-page.body.drive.tit',
    icon: iconTraining,
    points: [
      'expertise-page.body.drive.txt[0]',
      'expertise-page.body.drive.txt[1]',
      'expertise-page.body.drive.txt[2]',
      'expertise-page.body.drive.txt[3]',
      'expertise-page.body.drive.txt[4]',
    ],
  },
]);

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true,
  });
});
</script>

<template>
  <div class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1 class="title">{{ $t('expertise-page.home.title') }}</h1>
    </div>
  </div>

  <main class="main-content">
    <div class="expertise-list">
      <div
        v-for="(item, index) in expertiseItems"
        :key="index"
        class="expertise-card"
        data-aos="fade-up"
      >
        <div class="card-icon-wrapper">
          <img :src="item.icon" :alt="$t(item.titleKey)" class="card-icon" />
        </div>
        <div class="card-text-content">
          <h2 class="card-title">{{ $t(item.titleKey) }}</h2>
          <ul class="card-points-list">
            <li v-for="(point, pIndex) in item.points" :key="pIndex">
              {{ $t(point) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.hero-section {
  background-image: url("../assets/rectangle-31@2x.webp");
  background-position: center center;
  background-size: cover;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 45, 97, 0.6);
}

.hero-content {
  position: relative;
  z-index: 2;
}

.title{
  font-size: 3rem;
  color: white;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 0.5rem;
}

.title::after{
  content: "";
  position: absolute;
  background: #fcbc0d; /* Accent Gold */
  width: 80px;
  height: 4px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.main-content {
  padding: 6rem 5%;
  background-color: #f8f9fa;
}

.expertise-list {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.expertise-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.07);
  padding: 2.5rem;
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.expertise-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 35px rgba(0, 0, 0, 0.1);
}

.card-icon-wrapper {
  background-color: #eef3fb;
  border-radius: 50%;
  padding: 20px;
  flex-shrink: 0;
}

.card-icon {
  width: 40px;
  height: 40px;
  display: block;
}

.card-text-content {
  flex-grow: 1;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0A2D61;
  margin: 0 0 1.5rem 0;
}

.card-points-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.card-points-list li {
  position: relative;
  padding-left: 25px;
  color: #555;
  line-height: 1.6;
}

.card-points-list li::before {
  content: '✔';
  position: absolute;
  left: 0;
  color: #0A2D61;
  font-weight: bold;
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }
  .expertise-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 2rem;
  }
  .card-points-list li {
    text-align: left;
  }
}
</style>
